import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Grid, Box, Button, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { toggleLoginScreen } from '../reducers/UiReducer';
import { useDispatch, useSelector } from 'react-redux';
import { agentloginDispatch } from '../reducers/UserReducer';
import { useNavigate } from 'react-router-dom';
const logInSchema = Yup.object().shape({
	username: Yup.string().email().required('Email is required'),
	password: Yup.string()
		.required('Password is required')
		.min(4, 'Password is too short - should be 4 chars minimum'),
});
const LoginForm = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { loadinguser } = useSelector((state) => state.user);
	return (
		<div>
			<Grid container>
				<Grid item xs={5}>
					<img
						src='https://images.ixigo.com/rt-udaan/pc/img/login/banner.png?v=1'
						style={{ width: '100%' }}
					/>
				</Grid>
				<Grid item xs={7}>
					<Formik
						initialValues={{
							username: 'sales@musafirbazar.com',
							password: '1234',
						}}
						validationSchema={logInSchema}
						onSubmit={(values) => {
							console.log('values', values);
							dispatch(agentloginDispatch(values, navigate));
						}}>
						{(formik) => {
							const { errors, touched, isValid, dirty } = formik;
							return (
								<Form>
									<Box style={{ textAlign: 'end' }}>
										<CloseIcon
											style={{ cursor: 'pointer' }}
											onClick={() => dispatch(toggleLoginScreen(false))}
										/>
									</Box>

									<Grid
										container
										style={{
											padding: 30,
											marginTop: 60,
										}}>
										<h2>Log in to Musafirbazar</h2>

										<Grid item xs={12}>
											<Field
												type='email'
												name='username'
												style={{
													width: '95%',
													padding: 12,
													border: errors.username
														? '2px solid red'
														: '1px solid grey',
													borderRadius: 5,
													marginTop: 10,
												}}
												placeholder='Enter your email or username'
												id='username '
											/>
											{errors.username ? (
												<span style={{ color: 'red', fontSize: 12 }}>
													{errors.username}
												</span>
											) : null}
										</Grid>
										<Grid item xs={12} style={{ marginTop: 20 }}>
											<Field
												type='password'
												name='password'
												style={{
													width: '95%',
													padding: 12,
													border: errors.password
														? '2px solid red'
														: '1px solid grey',
													borderRadius: 5,
												}}
												placeholder='Enter your password'
												id='password'
											/>
											{errors.password ? (
												<span style={{ color: 'red', fontSize: 12 }}>
													{errors.password}
												</span>
											) : null}
										</Grid>
										<Grid item xs={12} style={{ marginTop: 50 }}>
											{loadinguser ? (
												<Box style={{ textAlign: 'center' }}>
													<CircularProgress color='inherit' size={30} />
												</Box>
											) : (
												<Button
													type='submit'
													variant='contained'
													style={{
														color: 'white',
														background: 'orange',
														width: '100%',
													}}>
													Login
												</Button>
											)}
										</Grid>

										<Box mt={2} style={{ textAlign: 'center' }}>
											<h3 style={{ color: 'red' }}>!! Wrong Password !!</h3>
										</Box>
									</Grid>
								</Form>
							);
						}}
					</Formik>
				</Grid>
			</Grid>
		</div>
	);
};

export default LoginForm;
